import { CarSearch } from '../models/car-search.model';
import { RealEstateSearch } from '../models/real-estate-search.model';

export type SavedSearchDomain = 'CAR' | 'REAL_ESTATE';
export const CAR_FIELDS = [
  'isForRent', 'conditions', 'yearFrom', 'yearTo', 'priceFrom',
  'priceTo', 'onlyWithPrice', 'name', 'models', 'bodyTypes',
  'carUseTypes', 'driveTypes', 'seatCovers', 'fuelTypes', 'colors',
  'interiorColors', 'kilometersFrom', 'kilometersTo', 'seatFrom', 'seatTo',
  'doorFrom', 'doorTo', 'performanceFrom', 'performanceTo', 'cylinderFrom',
  'cylinderTo', 'weightFrom', 'weightTo', 'withWarranty', 'isAccident',
  'isManulaGear', 'hasSunroof', 'hasPanoramicSunroof', 'hasFrontCamera', 'hasRearCamera',
  'hasCentralLock', 'hasSportSeats', 'hasCruiseControl', 'hasAbs', 'hasAlarmSystem',
  'hasSeatHeating', 'hasSteeringWheelHeating', 'hasElectricWindows', 'hasElectricMirrors', 'hasElectricTailgate',
  'hasReserveTire', 'hasWirelessCharging', 'has360Camera', 'hasFrontSensor', 'hasRearSensor'
] as const;
export const PROPERTY_FIELDS = [
  'isForRent', 'conditions', 'yearFrom', 'yearTo', 'priceFrom',
  'priceTo', 'onlyWithPrice', 'propertyTypes', 'typeOfPossessions', 'isFurnished',
  'floorAreaFrom', 'floorAreaTo', 'landAreaFrom', 'landAreaTo', 'floorNumberFrom',
  'floorNumberTo', 'numberOfFloorsFrom', 'numberOfFloorsTo', 'roomsFrom', 'roomsTo',
  'bedroomsFrom', 'bedroomsTo', 'bathroomsFrom', 'bathroomsTo', 'hasBalcony',
  'hasGarden', 'hasPool', 'hasParking', 'hasLift', 'hasSolarEnergy'
] as const;
export const BOUNDS = [
  'northEastLat', 'northEastLng', 'southWestLat', 'southWestLng'
] as const;
export type SavedGeography = Partial<Pick<CarSearch, 'polygonFilter' | typeof BOUNDS[number]>>;
export type SavedSearchCriteria = Partial<Pick<CarSearch, typeof CAR_FIELDS[number]> & Pick<RealEstateSearch, typeof PROPERTY_FIELDS[number]>> & SavedGeography;
export interface CreateSavedSearch { domain: SavedSearchDomain; criteria: SavedSearchCriteria; name?: string | null; }
export interface SavedSearch extends CreateSavedSearch { reactivated?: boolean; id: number; name: string | null; criteriaVersion: number; createdAt: string; isActive: boolean; unsubscribedAt: string | null; }
export interface SavedSearchPage { items: SavedSearch[]; total: number; pageIndex: number; pageSize: number; }

// Explicit allowlist: no execution fields, moderator fields, owner IDs or live viewport.
export function criteriaSnapshot(domain: SavedSearchDomain, form: Record<string, unknown>, geography: SavedGeography): SavedSearchCriteria {
  const result: Record<string, unknown> = {};
  for (const key of domain === 'CAR' ? CAR_FIELDS : PROPERTY_FIELDS) {
    const value = form[key];
    if (value == null || value === '' || (Array.isArray(value) && !value.length)) continue;
    if (key === 'onlyWithPrice' && value !== true) continue;
    result[key] = value;
  }
  return structuredClone({ ...result, ...geography }) as SavedSearchCriteria;
}
export function rectangle(query: unknown): SavedGeography {
  const q = (query ?? {}) as Record<string, unknown>;
  return BOUNDS.every(k => typeof q[k] === 'number' && Number.isFinite(q[k]))
    ? Object.fromEntries(BOUNDS.map(k => [k, q[k]])) as SavedGeography : {};
}
